import React, { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    console.error("Error boundary caught:", error);
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
          <Card className="max-w-md">
            <CardContent className="pt-6 space-y-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">
                  Noe gikk galt
                </h2>
                <p className="text-sm text-gray-600 mt-2">
                  Vi beklager, men noe uventet skjedde. Prøv igjen.
                </p>
              </div>
              {process.env.NODE_ENV === "development" && this.state.error && (
                <details className="text-xs text-gray-500">
                  <summary>Detaljer (dev)</summary>
                  <pre className="mt-2 bg-gray-100 p-2 rounded overflow-auto">
                    {this.state.error.message}
                  </pre>
                </details>
              )}
              <Button onClick={this.resetError} className="w-full">
                Prøv igjen
              </Button>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
